// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
export const Team = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #f9f9f9;

  [data-type='meet-team-title'] {
    text-align: center;
    margin: 24px 0px;
  }

  [data-type='title'] {
    color: #333;
    font-size: 44px;
    line-height: 50px;
    text-align: left;
    margin: 50px auto 10px;
  }

  [data-section='showcase'] {
    display: flex;
    width: 100%;
    max-height: 650px;
    [data-type='bio'] {
      width: 50%;
    }

    img {
      width: 50%;
      height: auto;
      object-fit: contain;
    }

    [data-type='bio'] {
      max-width: 550px;
      margin: 50px auto;
      display: flex;
      justify-content: center;
      align-items: center;

      [data-section='content'] {
        max-width: 550px;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        img {
          display: none;
        }
      }

      p {
        margin: 0;
      }

      [data-type='rule'] {
        width: 90px;
        border-top: 1px solid #333333;
      }

      [data-type='callout'] {
        color: #333;
        font-size: 30px;
        line-height: 50px;
      }

      [data-type='name'] {
        color: #333;
        font-size: 44px;
        line-height: 40px;
        margin: 25px 0 0;
      }

      [data-type='title'] {
        font-size: 14px;
        line-height: 28px;
        letter-spacing: 2.24px;
        text-transform: uppercase;
      }

      [data-type='blurb'] {
        color: #333;
        font-size: 22px;
        line-height: 40px;
        margin: 25px 0 0;
      }
    }

    /* Mobile */
    @media (max-width: 1240px) {
      height: 400px;
      [data-type='bio'] {
        [data-type='blurb'] {
          font-size: 16px;
          line-height: 1.5em;
          padding-right: 20px;
        }
      }
    }

    @media (max-width: 900px) {
      height: auto;
      border: 1px solid #dcdcdc;
      > img {
        display: none;
      }

      [data-type='bio'] {
        width: 100%;
        padding: 0;
        margin: 20px;
        max-width: initial;
      }
      [data-type='rule'] {
        display: none;
      }
      [data-type='bio'] [data-section='content'] {
        text-align: center;
        img {
          margin: 0 auto;
          display: block;
          width: 200px;
          height: 200px;
          border-radius: 50%;
          object-fit: fill;
        }
      }
      [data-type='bio'] {
        [data-type='title'] {
          text-align: center;
        }
        [data-type='blurb'] {
          font-size: 14px;
        }
      }
    }
  }

  [data-section='member-list'] {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 0;
    row-gap: 1px;
    background: #dcdcdc;
    column-rule: solid 1px #dcdcdc;
    width: 100%;

    [data-type='team-member'] {
      background: #f9f9f9;
      width: 100%;
      cursor: pointer;
      height: 380px;
      max-height: 380px;
      padding: 30px 0;
      display: flex;
      justify-content: center;
      align-items: center;

      [data-type='content'] {
        border-left: solid 1px #dcdcdc;
        padding: 0 25px;
        width: 100%;
      }

      [data-type='image'] {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        img {
          width: 180px;
          height: 180px;
          border-radius: 50%;
          visibility: visible;
          opacity: 1;
          transition: visibility 0.2s ease-in-out 0s, height 0.2s ease-in-out 0s,
            opacity 0.2s ease-in-out 0s;
        }
      }

      p {
        margin: 0;
      }

      [data-type='bio'] {
        position: relative;
        overflow: hidden;

        button,
        [data-type='toggle'] {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
        }

        [data-section='content'] {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        [data-type='name'] {
          font-size: 30px;
          line-height: 36px;
          font-weight: normal;
          margin: 10px 0px 0px;
          transition: all 0.2s ease-in-out 0s;
          margin: 25px 0 0;
        }

        [data-type='title'] {
          font-size: 18px;
          line-height: 20px;
          padding: 0px 20px;
          transition: all 0.2s ease-in-out 0s;
        }

        [data-type='icon'] {
          margin-top: 10px;
          width: 20px;
          height: 16px;
        }

        [data-type='blurb'] {
          height: 0;
          visibility: none;
          opacity: 0;
          margin: 25px 0 0;
          color: #333;
          text-align: center;
          font-size: 16px;
          line-height: 26px;
          transition: all 0.2s ease-in-out 0s;
        }
      }

      &[data-toggle] {
        [data-type='image'] {
          img {
            height: 0;
            visibility: none;
            opacity: 0;
          }
        }
        [data-type='bio'] {
          [data-type='name'] {
            margin: 10px 3px 0 0;
          }
          [data-type='title'] {
            margin: 1px 0 0;
          }
          [data-type='blurb'] {
            height: 210px;
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }

    /* Desktop */
    @media (min-width: 1240px) {
      svg[data-type='icon'] {
        display: none;
      }

      [data-type='team-member'] {
        &:nth-child(4n + 1) {
          [data-type='content'] {
            border-left: none;
          }
        }
      }

      [data-type='team-member']:hover {
        [data-type='image'] {
          img {
            height: 0;
            visibility: none;
            opacity: 0;
          }
        }
        [data-type='bio'] {
          [data-type='name'] {
            margin: 10px 3px 0 0;
          }
          [data-type='title'] {
            margin: 1px 0 0;
          }
          [data-type='blurb'] {
            height: 210px;
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }

    /* Mobile */
    @media (max-width: 1124px) {
      grid-template-columns: repeat(2, 1fr);

      [data-type='team-member'] {
        &[data-toggle] {
          height: auto;

          [data-type='blurb'] {
            height: 210px;
            visibility: visible;
            opacity: 1;
          }
        }

        &:nth-child(even) {
          [data-type='content'] {
            border-left: solid 1px #dcdcdc;
          }
        }
        &:nth-child(odd) {
          [data-type='content'] {
            border-left: none;
          }
        }
      }
    }

    @media (max-width: 1240px) and (min-width: 900px) {
      [data-layout='landing'] & {
        grid-template-columns: repeat(3, 1fr);

        [data-type='team-member'] {
          &[data-toggle] {
            height: auto;

            [data-type='blurb'] {
              height: 210px;
              visibility: visible;
              opacity: 1;
            }
          }

          &:nth-child(even),
          &:nth-child(odd) {
            [data-type='content'] {
              border-left: solid 1px #dcdcdc;
            }
          }

          &:nth-child(3n + 1) {
            [data-type='content'] {
              border-left: none;
            }
          }
        }
      }
    }

    @media (max-width: 650px) {
      grid-template-columns: repeat(1, 1fr);

      [data-type='team-member'] {
        &:nth-child(n) {
          [data-type='content'] {
            border-left: none;
          }
        }
      }
    }

    [data-section='team-member-content'] {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 16px;
    }
  }
`